// extracted by mini-css-extract-plugin
export default {"updated":"styles_updated__277U4","terms":"styles_terms__xIZ60","disclaimer":"styles_disclaimer__INgvv"};